// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import type { Icon } from 'iconsax-react';

const DownloadArrowIcon: Icon = ({ size = 20, color, variant: _variant, className, style, ...rest }) => {
  const fill = color || 'currentColor';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-icon="download arrow"
      className={className}
      style={style}
      {...rest}
    >
      <path d="M10 13.75L4.375 8.125L5.5625 6.9375L9.0625 10.4375V0.625H10.9375V10.4375L14.4375 6.9375L15.625 8.125L10 13.75ZM2.5 19.375C1.8125 19.375 1.2239 19.1301 0.734375 18.6406C0.244792 18.1511 0 17.5625 0 16.875V13.75H1.875V16.875C1.875 17.0833 1.94792 17.2656 2.09375 17.4219C2.23958 17.5781 2.41667 17.6562 2.625 17.6562H17.375C17.5833 17.6562 17.7604 17.5781 17.9062 17.4219C18.0521 17.2656 18.125 17.0833 18.125 16.875V13.75H20V16.875C20 17.5625 19.7552 18.1511 19.2656 18.6406C18.7761 19.1301 18.1875 19.375 17.5 19.375H2.5Z" fill={fill} />
    </svg>
  );
};

export { DownloadArrowIcon };
